import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { allIcons } from "../../../assets";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import appcolors from "../../../constants/Colors";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "1100px",
  margin: "auto",
  padding: "45px 16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },

  "& .MuiAccordion-root": {
    boxShadow: "none",
  },
}));

let appDownload = [
  {
    link: "",
    icons: allIcons.appStoreLogo,
    title: "App Store",
    description:
      "You can easily download the app in your Apple mobile phone...",
  },
  {
    link: "",
    icons: allIcons.googlePlayLogo,
    title: "Play Store",
    description:
      "You can easily download the app in your Android mobile phone...",
  },
];

const faqs = [
  {
    question: "How to setup LOBA app?",
    answer:
      "Download our app easily from the App Store or Google Play. Simply search for our salon and spa management app, tap 'Install', and start managing your bookings effortlessly.",
  },
  {
    question: "Can I use find spa nearly my area?",
    answer:
      "You can contact our customer support team via email at support@example.com or call us at 123-456-7890.",
  },
  {
    question: "How book my first appointment?",
    answer:
      "Yes, we offer international shipping to most countries. Shipping fees and delivery times vary by location.",
  },
  {
    question: "Can i pay my service online?",
    answer:
      "We accept major credit cards, PayPal, and other secure payment options.",
  },
];

function Help() {
  const [expanded, setExpanded] = useState(0);

  console.log(expanded, "expandedexpandedexpanded");

  const renderLinks = () => {
    return (
      <List>
        {appDownload?.map((val, ind) => {
          return (
            <ListItem
              key={ind}
              sx={{ px: 0, color: "#ffffff", alignItems: "flex-start" }}
            >
              <ListItemIcon sx={{ minWidth: 35, mt: 1 }}>
                <img src={val.icons} alt={val.title} width={25} />
              </ListItemIcon>
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary ": {
                    fontSize: "1.125rem",
                    mt: 0,
                  },
                  "& .MuiListItemText-secondary ": {
                    color: "#ffffff",
                    fontWeight: 200,
                  },
                }}
                primary={val.title}
                secondary={
                  <>
                    {val.description}{" "}
                    <Link
                      href={val.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      Link
                    </Link>
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <Box bgcolor={"#000000"} my={{ xs: 3, md: 6 }}>
      <MainView>
        <Grid container spacing={{ xs: 2, md: 4 }} alignItems={"center"}>
          <Grid item xs={12} md={6}>
            <Typography variant="h1" className="lpl_rs_pr">
              We are always here for your Help.
            </Typography>

            <Typography
              mt={1.5}
              fontWeight={200}
              variant="body1"
              color={"#ffffff"}
            >
              "Download our app easily from the App Store or Google Play. Simply
              search for our salon and spa management app, tap 'Install', and
              start managing your bookings effortlessly."
            </Typography>
            {renderLinks()}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              borderTop={`4px solid ${appcolors.primary}`}
              borderRadius={"4px"}
              bgcolor={"#ffffff"}
            >
              {faqs.map((faq, index) => (
                <Accordion
                  key={index}
                  expanded={expanded === index}
                  onChange={() => setExpanded(expanded === index ? -1 : index)}
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === index ? (
                        <KeyboardArrowDownIcon />
                      ) : (
                        <img
                          src={allIcons.conformIcon}
                          alt={"confirm-icon"}
                          width={25}
                        />
                      )
                    }
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <Typography variant="body1" fontWeight={600}>
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      variant="body2"
                      color={"#161C2D"}
                      fontWeight={300}
                    >
                      "{faq.answer}"
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Grid>
        </Grid>
      </MainView>
    </Box>
  );
}

export default Help;
